export const KEY = {
  keyAuthLocal: 'userInfo',
  keyTokenLocal: 'token',
  loginRemember: 'loginRemember',
  BASE_URL: process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : 'http://localhost:1337/api',
  MAP: process.env.REACT_APP_MAP_API_KEY ? process.env.REACT_APP_MAP_API_KEY : '',
};
